module.exports = __webpack_public_path__ + "static/assets/80fa4b6a2113e1b99f00ef590497261c.png";